import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { useWaveById } from "@/hooks/useWaveById";
import { useWaveDecisions } from "@/hooks/waves/useWaveDecisions";
import { getRenderableWaveDecisionWinners } from "@/helpers/waves/wave-decision.helpers";
import { toApiWaveMin } from "@/helpers/waves/wave.helpers";
type NextMintDropState = {
  readonly nextMint: ApiDrop | null;
  readonly nextMintTitle: string | null;
  readonly waveId: string | null;
  readonly isReady: boolean;
  readonly isSettingsLoaded: boolean;
  readonly isFetching: boolean;
};
export const useNextMintDrop = () => {
  const $ = _c(16);
  const {
    seizeSettings,
    isLoaded
  } = useSeizeSettings();
  const waveId = seizeSettings.memes_wave_id;
  const t0 = !!waveId;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      enabled: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    wave
  } = useWaveById(waveId, t1);
  const t2 = waveId ?? "";
  const t3 = !!waveId;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      waveId: t2,
      enabled: t3,
      pageSize: 1
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    decisionPoints,
    isFetching
  } = useWaveDecisions(t4);
  const latestDecision = decisionPoints[decisionPoints.length - 1];
  let nextMint;
  let t5;
  if ($[5] !== latestDecision?.winners || $[6] !== wave) {
    const rawNextMint = getRenderableWaveDecisionWinners(latestDecision?.winners ?? [])[0]?.drop ?? null;
    nextMint = rawNextMint && wave ? {
      ...rawNextMint,
      wave: toApiWaveMin(wave)
    } : rawNextMint;
    t5 = nextMint?.title ?? nextMint?.metadata.find(_temp)?.data_value ?? null;
    $[5] = latestDecision?.winners;
    $[6] = wave;
    $[7] = nextMint;
    $[8] = t5;
  } else {
    nextMint = $[7];
    t5 = $[8];
  }
  const nextMintTitle = t5;
  const t6 = isLoaded && !!waveId;
  const t7 = isFetching || !isLoaded && !!waveId;
  let t8;
  if ($[9] !== isLoaded || $[10] !== nextMint || $[11] !== nextMintTitle || $[12] !== t6 || $[13] !== t7 || $[14] !== waveId) {
    t8 = {
      nextMint,
      nextMintTitle,
      waveId,
      isReady: t6,
      isSettingsLoaded: isLoaded,
      isFetching: t7
    };
    $[9] = isLoaded;
    $[10] = nextMint;
    $[11] = nextMintTitle;
    $[12] = t6;
    $[13] = t7;
    $[14] = waveId;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp(m) {
  return m.data_key === "title";
}